'use strict';

export class LoginResponse {
  constructor() {

  }

  static loginTo(userService) {
    return (response, statsus, headers, config) => {
      // Get jwtoken from respons header
      let jwtoken = response.headers('jwtoken');
      if (!jwtoken && response) {
        // Fallback to response body
        jwtoken = response.data && response.data.jwtoken;
      }
      if (jwtoken) {
        userService.login(jwtoken);
      }
      return response;
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-response/src/loginResponse.js